import {Accordion, AccordionDetails, AccordionSummary, Card, Grid} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {SwitchSegmentedYesNo, TextBox} from '../../../Core/UI';
import React from 'react';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {SelectInputElement} from '../Components/SelectInputElement';
import {observer} from 'mobx-react-lite';
import {HealthQuestionsProps} from './HealthQuestionsList';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/HealthXref';

const HighBloodPressure = observer(({counter, valueChanged, parameters, coreQuestions}: HealthQuestionsProps) => {
    return (
        <Accordion style={{width: '100%'}} TransitionProps={{unmountOnExit: true}}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={'highBloodPressure-content'}
                id={'highBloodPressure-header'}
            >
                <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                    <div>High Blood Pressure</div>
                    <div>{counter('highBloodPressure')}</div>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container>
                    <Grid key="params" container>
                        {coreQuestions?.map(({name, label}) => (
                            <Grid item xs={4} key={name}>
                                <SwitchSegmentedYesNo
                                    param={{
                                        name: name,
                                        label: label,
                                        category: 'highBloodPressure',
                                        ...(parameters[name as keyof typeof parameters] as Parameter),
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                />
                            </Grid>
                        ))}
                        {parameters.Bloodpressure.value && (
                            <Grid item xs={12} style={{marginTop: 10}}>
                                <Card style={{padding: 20}}>
                                    <strong>Blood pressure</strong>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DatePicker
                                                    inputVariant="outlined"
                                                    variant="inline"
                                                    openTo="year"
                                                    views={['year', 'month']}
                                                    label="When were you diagnosed?"
                                                    style={{width: '100%', marginTop: 8}}
                                                    value={parameters.bpDiagnosisDate?.value || null}
                                                    onChange={(date) => {
                                                        valueChanged(parameters.bpDiagnosisDate, date);
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <SelectInputElement
                                                param={{
                                                    label: 'How many medications are you taking?',
                                                    name: 'bpNumMedications',
                                                    options: fieldOptions.bpNumMedications.options,
                                                    ...parameters.bpNumMedications,
                                                }}
                                                required={''}
                                                valueChanged={valueChanged}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextBox
                                                id="bpReadingLow"
                                                label="What was your last low blood pressure reading?"
                                                value={parameters.bpReadingLow?.value}
                                                onChange={(value) => valueChanged(parameters.bpReadingLow, value)}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextBox
                                                id="bpReadingHigh"
                                                label="What was your last high blood pressure reading?"
                                                value={parameters.bpReadingHigh?.value}
                                                onChange={(value) => valueChanged(parameters.bpReadingHigh, value)}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextBox
                                                id={'bpMedications'}
                                                label={'How many medications are you taking? (Deprecated)'}
                                                value={parameters.bpMedications?.value}
                                                onChange={(value) => valueChanged(parameters.bpMedications, value)}
                                                type="number"
                                            />
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
});

export default HighBloodPressure;
